// import { RequestProxyUrl } from './imageUrl';

// resize a given image to a given width and height
export async function createResizedImageCrossOrigin(imagePath, width, height) {
    console.log(`Create Resized Image Origin: ${imagePath}`);

    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous"; // set the crossorigin attribute

        img.onload = () => {
            // Clear the event handlers
            img.onload = null;
            img.onerror = null;

            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            resolve(canvas.toDataURL());
        };

        img.onerror = (errorEvent) => {
            // Clear the event handlers
            img.onload = null;
            img.onerror = null;
            
            reject(new Error(`Failed to load and resize image at path: ${imagePath}. Reason: ${errorEvent.message}`));
        };

        img.src = imagePath;
    });
}

export async function createResizedExternalImage(imagePath, width, height) {
  console.log(`Create Resized Image Origin: ${imagePath}`);

  return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous"; // set the crossorigin attribute

      img.onload = () => {
          // Clear the event handlers
          img.onload = null;
          img.onerror = null;

          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          resolve(canvas.toDataURL());
      };

      img.onerror = (errorEvent) => {
          // Clear the event handlers
          img.onload = null;
          img.onerror = null;
          
          reject(new Error(`Failed to load and resize image at path: ${imagePath}. Reason: ${errorEvent.message}`));
      };

      // img.src = RequestProxyUrl(imagePath);
      img.src = imagePath;
  });
}

export async function createCanvasOverlay(canvasDataURL1, canvasDataURL2) {
    return new Promise(async (resolve, reject) => {
      const canvas1 = document.createElement('canvas');
      const ctx1 = canvas1.getContext('2d');
      const image1 = new Image();
      const image2 = new Image();
  
      try {
        await Promise.all([loadImage(image1, canvasDataURL1), loadImage(image2, canvasDataURL2)]);
  
        canvas1.width = image1.width;
        canvas1.height = image1.height;
        ctx1.drawImage(image1, 0, 0);
        ctx1.drawImage(image2, 0, 0);
  
        resolve(canvas1.toDataURL());
      } catch (error) {
        reject(error);
      }
    });
}

export async function convertBase64ToImage(base64ImageString) {
  const newImage = new Image();
  newImage.src = base64ImageString;
  return newImage;
}

//===============================
// internal utility functions
//===============================
const loadImage = (imgRef, src) => {
    return new Promise((resolve, reject) => {
      imgRef.onload = () => {
        resolve(imgRef);
        imgRef.onload = null; // Clear the event listener
        imgRef.onerror = null; // Clear the event listener
      };
      imgRef.onerror = (error) => {
        reject(new Error(`Failed to load image with source: ${src}. Reason: ${error.message}`));
        imgRef.onload = null; // Clear the event listener
        imgRef.onerror = null; // Clear the event listener
      };

      console.log(`loadImage: ${src}`);

      imgRef.src = src;
    });
};
  


